
import React from "react";
import moment from "moment";

export const ChatContent = ({ chat }) => {
	let message = chat.message;
	const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
	if (chat.message_type === 'list') {
		let content = JSON.parse(chat.template.content);
		content.content = content.content.replace(/<p(\s*[^>]*)>/g, '<div$1>').replace(/<\/p>/g, '</div>');

		message = content.content;
		if (typeof content.options !== 'undefined') {
			message += '<br/><div className="text-center"><h6><i class="mdi mdi-format-list-bulleted"></i>Service Options</h6></div>'
			message += '<ul>';
			content.options.map((option, index) => {
				message += '<li>';
				message += option;
				message += '</li>';
			});
			message += '</ul>';
		}
		message = renderHTML(message);
	} else if (chat.message_type === 'text' && chat.template_id !== null) {
		let content = JSON.parse(chat.template.content);
		message = renderHTML(content.content);
	} else if (chat.message_type === 'button' && chat.template_id !== null) {
		let content = JSON.parse(chat.template.content);
		message = content.content;
		if (typeof content.buttons !== 'undefined') {
			message += '<div>';
			content.buttons.map((button, index) => {
				message += '<button type="button" class="cx-btn cx-btn-primary">' + button + '</button>&nbsp;&nbsp;';
			});
			message += '</div>';
		}
		message = renderHTML(message);
	}
	return message;
}

export const ChatTime = ({ chat }) => {
	console.log("ChatTime component received:", chat);
	console.log("ChatTime date_time value:", chat.date_time);
	// const chatDate = moment(chat.date_time);
	const chatDate = moment.utc(chat.date_time).local();
	console.log("Moment parsed time:", chatDate.format());
	const now = moment();
	const formattedTime = chatDate.format('h:mm A'); // e.g., 10:45 AM

	let formattedDate;

	if (chatDate.isSame(now, 'day')) {
		formattedDate = `Today`;
	} else {
		formattedDate = chatDate.format('DD-MM-YYYY'); // e.g., 12-09-2024
	}

	return (
		<span className={chat.messaged_by === 'user' ? 'date-time see' : 'date-time'}>
		{/* // <span className={chat.message_by === 'user' ? 'date-time see' : 'date-time'}> */}
			<i className="ri-check-double-line"></i>{formattedTime}, {formattedDate}
		</span>
	);
}